import classnames from 'classnames';

import { ExistingReferralPopupParams } from '@store/App/App';

import { Button, ButtonTheme } from '@components/Button';
import { Popup, PopupModifiers } from '@components/Popup';

import style from '@core/Page/Page.module.scss';
import '@components/mixins/commonStyles.scss';
import { MedicalCasePageTestAttributes } from 'chaika-test-attributes';
import { translate } from '@chaika/i18n/helper';

interface Props extends ExistingReferralPopupParams {}

function ExistingReferralPopup({
    sameMedicalCase,
    title,
    serviceName,
    caseName,
    doctorName,
    onAddClick,
    onCreateClick,
    onCancel,
}: Props) {
    const titleLines = title.split('\n').map(line => <p key={line}>{line}</p>);
    return (
        <Popup
            modifiers={[PopupModifiers.NoPaddings]}
            onOutOfContentClick={onCancel}
        >
            <div className={style.referralPopup}>
                <div className={classnames([style.referralPopup_title, 'font_h2'])}>{titleLines}</div>
                {!sameMedicalCase && (
                    <>
                        <div>
                            <div className={classnames([style.referralPopup_serviceTitle, 'font_label'])}>
                                {translate('previouslyReferral')}
                            </div>
                            <div className={classnames([style.referralPopup_serviceName, 'font_h3'])}>
                                {serviceName}
                            </div>
                        </div>
                        <div className={style.referralPopup_caseInfo}>
                            <div>
                                <span className={classnames([style.referralPopup_caseTitle, 'font_label'])}>
                                    {translate('episode')}:
                                </span>
                                <span>{caseName}</span>
                            </div>
                            <div>
                                <span className={classnames([style.referralPopup_caseTitle, 'font_label'])}>
                                    {translate('directed')}:
                                </span>
                                <span>{doctorName}</span>
                            </div>
                        </div>
                    </>
                )}
                <div className={style.referralPopup_buttons}>
                    {!sameMedicalCase && (
                        <Button
                            dataTest={MedicalCasePageTestAttributes.AddSameButton}
                            theme={ButtonTheme.Main}
                            onClick={onAddClick}
                        >
                            {translate('add')}
                        </Button>
                    )}
                    <Button
                        dataTest={MedicalCasePageTestAttributes.CreateNewButton}
                        theme={sameMedicalCase ? ButtonTheme.Main : ButtonTheme.Secondary}
                        onClick={onCreateClick}
                    >
                        {sameMedicalCase ? translate('yes') : translate('createNew')}
                    </Button>
                    <div className={classnames([!sameMedicalCase && style.referralPopup_cancelButton])}>
                        <Button
                            dataTest={MedicalCasePageTestAttributes.CancelButton}
                            theme={ButtonTheme.White}
                            onClick={onCancel}
                        >
                            {sameMedicalCase ? translate('no') : translate('cancel')}
                        </Button>
                    </div>
                </div>
            </div>
        </Popup>
    );
}

export { ExistingReferralPopup };
